import { render, staticRenderFns } from "./FirstEmpty.vue?vue&type=template&id=2f0f73b4&scoped=true"
import script from "./FirstEmpty.vue?vue&type=script&lang=js"
export * from "./FirstEmpty.vue?vue&type=script&lang=js"
import style0 from "./FirstEmpty.vue?vue&type=style&index=0&id=2f0f73b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f73b4",
  null
  
)

export default component.exports